module.exports = __webpack_public_path__ + "img/screen-3.792e34c9.png";